<template>
	<div>
		<headTip></headTip>
		<router-view></router-view>
		<phoneFooter></phoneFooter>
	</div>
</template>

<script>
	import headTip from '../../components/headTip.vue'
	import phoneFooter from './components/phoneFooter.vue'

	export default {
		components: {
			headTip,
			phoneFooter
		},
	}
</script>

<style scoped>
</style>
